class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    const summary = this.mainDetailsToggle.querySelector('summary');
    this.content = summary ? summary.nextElementSibling : null;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut(event) {
    if (event.relatedTarget && this.contains(event.relatedTarget)) return;
    setTimeout(() => {
      if (!this.mainDetailsToggle || !this.mainDetailsToggle.hasAttribute('open')) return;
      if (!this.contains(document.activeElement)) this.close();
    }, 120);
  }

  onToggle() {
    if (!this.content) return;
    if (!this.animations) this.animations = this.content.getAnimations ? this.content.getAnimations() : [];

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play && animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel && animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.ss-chrome-header, .header-wrapper, .ss-shell[data-ss-sticky-header]');
  }

  onToggle() {
    if (!this.header) return;
    const open = this.mainDetailsToggle.open;
    this.header.preventHide = open;
    if (this.header._ssStickyInstance) {
      this.header._ssStickyInstance.preventHide = open;
    }

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
    document.documentElement.style.setProperty(
      '--ss-mega-top',
      `${Math.round(this.header.getBoundingClientRect().bottom + 8)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
